export default function SubHeadingTitle({ children }) {

    return (
        <h3 className="text-[#f7f8f8] text-xl sm:text-2xl font-semibold py-4">
            {children}
        </h3>
    )
}
